// src/components/AuthDebug.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

const AuthDebug = () => {
  const { user, token, isAuthenticated, loading } = useAuth();
  const [showDetails, setShowDetails] = useState(true);
  
  // Listen for storage changes
  useEffect(() => {
    const handleStorageChange = () => {
      console.log('🔄 Storage changed, refreshing debug...');
      // Force re-render
      setShowDetails(prev => !prev);
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);
  
  if (loading) return null;
  
  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      background: '#1e1e1e',
      color: '#0f0',
      padding: '10px',
      borderRadius: '8px',
      fontSize: '11px',
      fontFamily: 'monospace',
      zIndex: 9999,
      maxWidth: '350px',
      border: '1px solid #0f0',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      cursor: 'pointer'
    }} onClick={() => setShowDetails(!showDetails)}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
        <strong>🔐 Zustand Auth Store</strong>
        <span style={{ fontSize: '10px', color: '#888' }}>{showDetails ? '▼' : '▲'} click to toggle</span>
      </div>
      
      {showDetails && (
        <>
          <div style={{ borderTop: '1px solid #333', marginTop: '5px', paddingTop: '5px' }}>
            <div>📊 <strong>Status:</strong> {isAuthenticated ? '✅ LOGGED IN' : '❌ LOGGED OUT'}</div>
            <div>👤 <strong>User:</strong> {user ? user.email : 'None'}</div>
            <div>🔑 <strong>Token:</strong> {token ? '✅ Present' : '❌ None'}</div>
            
            {user && (
              <>
                <div>📛 <strong>Name:</strong> {user.name || 'N/A'}</div>
                <div>💼 <strong>Role:</strong> {user.role || 'N/A'}</div>
                <div>🆔 <strong>ID:</strong> {user.id || user._id || 'N/A'}</div>
              </>
            )}
            
            {token && (
              <div>🔐 <strong>Token Preview:</strong> {token.substring(0, 30)}...</div>
            )}
            
            <div style={{ marginTop: '5px', borderTop: '1px solid #333', paddingTop: '5px' }}>
              <div>💾 <strong>localStorage:</strong></div>
              <div style={{ fontSize: '9px', marginLeft: '10px' }}>
                <div>token: {localStorage.getItem('token') ? '✅' : '❌'}</div>
                <div>user: {localStorage.getItem('user') ? '✅' : '❌'}</div>
                <div>auth-storage: {localStorage.getItem('auth-storage') ? '✅' : '❌'}</div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AuthDebug;